module.exports = __webpack_public_path__ + "images/category_lp/macbook/store_images/2@2x_33469c1e6b1aafee964faa02aceb6377.png";